import { ProfitTtd } from '../../utils/pricing';

export interface ShownProfitPercents {
  /** Profit ÷ cost — the markup the line or quote realised. */
  ofCost: number;
  /** The denominator `ofCost` came from; not > 0 means print "—". */
  costBase: number;
  /** Profit ÷ final selling price — margin. */
  ofSelling: number;
  /** The denominator `ofSelling` came from; not > 0 means print "—". */
  sellingBase: number;
}

/**
 * The profit percentages the quotation screen STATES — the TT$ ones, whenever
 * a TT$ figure exists.
 *
 * Owner decision 2026-09-25: USC buys and banks in TT$, and the TT$ cost is the
 * pinned figure a line was priced from, while the US$ cost is a cent-ceiled
 * restatement of it that can skew a cheap line's percentage badly (TT$0.05 x
 * 1000 at 30%: 100% in US$, 160% in TT$ — see `resolveProfitTtd`). So the
 * grid's "Profit against cost price" / "Profit against selling price" columns and both Pricing Summary
 * boxes print ONE percentage beside the US$ and the TT$ money, and it is this
 * one. The US$ percentage is the fallback only when there is no TT$ figure (no
 * rate, or a line with no quantity).
 *
 * Only the quotation screen shows these percentages — the exports, confirmed
 * orders and invoices print none — so this is a screen rule, not a pricing
 * owner, and has no server twin.
 */
export const shownProfitPercents = (
  usd: { profitPercentOfCost: number; marginPercent: number; cost: number; netSellingPrice: number },
  ttd: ProfitTtd | null
): ShownProfitPercents =>
  ttd
    ? { ofCost: ttd.profitPercentOfCost, costBase: ttd.costTtd, ofSelling: ttd.marginPercent, sellingBase: ttd.sellingTtd }
    : { ofCost: usd.profitPercentOfCost, costBase: usd.cost, ofSelling: usd.marginPercent, sellingBase: usd.netSellingPrice };
